import { createSlice } from "@reduxjs/toolkit";
import authnApi from "apis/eduidAuthn";
import securityApi from "apis/eduidSecurity";
import { FRONTEND_ACTION } from "components/Common/MultiFactorAuthentication";
// export for use in tests
export const initialState = { re_authenticate: false };
const authnSlice = createSlice({
    name: "authn",
    initialState,
    reducers: {
        setReAuthenticate: (state, action) => {
            state.re_authenticate = action.payload;
        },
        setAuthnFrontendReset: (state) => {
            state.frontend_action = undefined;
            state.frontend_state = undefined;
            state.response = undefined;
            sessionStorage.clear();
        },
        setFrontendActionAndState: (state, action) => {
            state.frontend_action = action.payload.frontend_action;
            state.frontend_state = action.payload.frontend_state;
            sessionStorage.setItem(FRONTEND_ACTION, action.payload.frontend_action);
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(authnApi.endpoints.authnGetStatus.matchFulfilled, (state, action) => {
            state.frontend_action = undefined;
            state.frontend_state = undefined;
            state.response = action.payload.payload;
        });
        builder.addMatcher(securityApi.endpoints.checkAuthnStatus.matchFulfilled, (state, action) => {
            if (state.response !== undefined) {
                state.response.frontend_action = action.payload.payload.frontend_action;
            }
        });
    },
});
export default authnSlice;
